import React from 'react';
import { update, remove } from 'ramda';

import {
  CondOperatorType,
  ExtendedOperatorType,
  IClientAssociationModel,
} from '../../../../../../../../Types/ClientModelTypes';
import {
  IUIPage,
  IExtendedConditionObject,
  ITypeTreeConditionObject,
  NonExtendedConditionObjectType,
} from '../../../../../../../../Types/UrvalTypes';
import EDGrid from '../../../../../../../../BaseComponents/GridComponents/EDGrid';
import ConditionLabel from '../../../ConditionLabel';
import Page from '../../../../../Sida/UrvalSida';
import EDDivider from '../../../../../../../../BaseComponents/Divider/EDDivider';
import { URVAL_INDENT } from '../../../../../../Consts/UrvalConsts';
import { getTypeConditionObject } from '../../../../../../Utils/urvalUtils';
import { ConditionValues } from '../../../ConditionValues/ConditionValues';
import { TEDSelectionExtendedOperator } from '../../../../../../../../globalQueryTypes';
import Logger, { namedError } from '../../../../../../../../Utils/Logger';
import ConditionMenu from '../../../ConditionMenu/ConditionMenu';
import { conditionOperators } from '../../../ConditionOperator/Consts/ConditionOperatorConsts';

interface IProps {
  inPages: IUIPage[];
  setInPages: (newPages: IUIPage[]) => void;
  association: IClientAssociationModel;
  operator: ExtendedOperatorType;
  setOperator: (newOperator: ExtendedOperatorType) => void;
  modelPath: IClientAssociationModel[];
  removeExtendedCondition: () => void;
  conditionObject: IExtendedConditionObject;
  setConditionObject: (newConditionObject: IExtendedConditionObject) => void;
  indention: number;
  disabled?: boolean;
}

class ExtendedUrval extends React.Component<IProps> {
  setInPage = (index: number) => (newPage: IUIPage) => {
    this.props.setInPages(update<IUIPage>(index, newPage, this.props.inPages));
  };

  removeInPage = (index: number) => () => {
    this.props.setInPages(remove<IUIPage>(index, 1, this.props.inPages));
  };

  /** Används för att kunna sätta typ om man bara har en sida */
  setFirstPageConditonObject =
    (index: number) => (newConditionObject: ITypeTreeConditionObject) => {
      const { inPages } = this.props;

      const newFirstPageConditionObjects = update(
        index,
        newConditionObject,
        inPages[0].conditionObjects
      );

      const newFirstPage: IUIPage = {
        ...inPages[0],
        conditionObjects: newFirstPageConditionObjects,
      };

      this.setInPage(0)(newFirstPage);
    };

  deleteFirstPageTypeConditonObject = () => {
    Logger.warn(
      namedError(
        'ExtendedUrval-CanNotDeleteTypeCondition',
        'Can not delete Type condition'
      )
    );
  };

  render() {
    const {
      association,
      conditionObject,
      removeExtendedCondition,
      indention,
      disabled,
    } = this.props;

    const inPages = conditionObject.condition[0].in;
    const onlyPage = inPages.length === 1 && inPages[0];

    const typeConditionInfo =
      onlyPage && getTypeConditionObject(onlyPage.conditionObjects);

    return (
      <div data-testid="extendedUrval">
        <EDGrid container spacing={0} alignItems="flex-end">
          <EDGrid item xs={12} sm={3} md={3}>
            <ConditionLabel
              indention={indention}
              displayLabel={`${association.DisplayLabel} - ${
                conditionOperators[this.props.operator].name
              }`}
              conditionObject={conditionObject}
              deleteConditionObject={removeExtendedCondition}
              disabled={disabled}
            />
          </EDGrid>
          <EDGrid item xs={12} sm={2} md={2} lg={1}>
            <ConditionMenu
              setConditionOperator={
                this.props.setOperator as (
                  newConditionOperator: CondOperatorType | ExtendedOperatorType
                ) => void
              }
              availableConditionOperatorKeys={[
                TEDSelectionExtendedOperator.all,
                TEDSelectionExtendedOperator.exists,
                TEDSelectionExtendedOperator.notexists,
              ]}
              disabled={disabled}
            />
          </EDGrid>
          <EDGrid item xs={12} sm={7} md={7} lg={8}>
            {typeConditionInfo && (
              <ConditionValues
                conditionObject={typeConditionInfo.object}
                setConditionObject={
                  this.setFirstPageConditonObject(typeConditionInfo.index) as (
                    newConditionObject: NonExtendedConditionObjectType
                  ) => void
                }
                deleteConditionObject={this.deleteFirstPageTypeConditonObject}
                disabled={disabled || false}
              />
            )}
          </EDGrid>
        </EDGrid>
        {this.props.inPages.map((page, index) => (
          <React.Fragment key={page.id}>
            {index === 0 && <EDDivider />}
            <Page
              indention={indention + 1}
              pageNr={index + 1}
              page={page}
              setPage={this.setInPage(index)}
              collectionName={association.AssociatedCollectionName}
              removePage={this.removeInPage(index)}
              existsMorePages={this.props.inPages.length > 1}
              disabled={disabled}
            />
            <EDDivider marginLeft={(indention + 1) * URVAL_INDENT} />
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default ExtendedUrval;
